//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { isDefined } from '@utils/filterPredicates';

const getPostDetails = (state: ICuralateStore) => state.pinterest.postDetails;
const getPostDetailsFlags = (state: ICuralateStore) =>
  getPostDetails(state).flags;

export const getIsDraftingPin = createSelector(
  getPostDetailsFlags,
  (flags) => flags.isDraftingPin,
);

export const getIsSchedulingPin = createSelector(
  getPostDetailsFlags,
  (flags) => flags.isSchedulingPin,
);

export const getIsInitializingBulkPinMedia = createSelector(
  getPostDetailsFlags,
  (flags) => flags.isInitializingBulkPinMedia,
);

export const getHasSetPostDetails = createSelector(
  getPostDetailsFlags,
  (flags) => flags.hasSetPostDetails,
);

export const getPinterestPostDetailsErrors = createSelector(
  getPostDetails,
  (postDetails) => postDetails.errors,
);

export const getSchedulingStep = createSelector(
  getPostDetails,
  (postDetails) => postDetails.schedulingStep,
);

export const getSchedulingEntryPoint = createSelector(
  getPostDetails,
  (postDetails) => postDetails.schedulingEntryPoint,
);

export const getDraftId = createSelector(
  getPostDetails,
  (postDetails) => postDetails.draftId,
);

export const getPostId = createSelector(
  getPostDetails,
  (postDetails) => postDetails.postId,
);

export const getIsEditingDraft = createSelector(getPostDetails, (postDetails) =>
  isDefined(postDetails.draftId),
);
